import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PatientDetails } from "../../models/dto/patient-details";
import { ViewStudy } from "../../models/view/view-study";
import { AuditItemsRequest, AuditRequest, ImportTypeEnum } from "./audit-request";

@Injectable({
    providedIn: 'root',
})

export class AuditService {

    private auditData: Map<string, AuditRequest> = new Map();

    constructor() {

    }

    addAuditData(idStudy: string, data: AuditRequest) {
        let auditElement: AuditRequest | undefined = this.auditData.get(idStudy);
        this.auditData.set(idStudy, data);
    }

    deleteAuditData(idStudy: string) {
        this.auditData.delete(idStudy);
    }

    deleteAllData() {
        this.auditData = new Map <string, AuditRequest>();
    }

    getAuditData() {
        return this.auditData;
    }

    convertToAuditRequest(row: ViewStudy, patientDetails: PatientDetails, items: AuditItemsRequest): AuditRequest {
        let req: AuditRequest = new AuditRequest(
            items.idUtente,
            items.importDate,
            items.importType,
            items.sourceCall,
            row.data.series.length,
            row.data.filesNumber,
            patientDetails.Issuer,
            patientDetails.PatientId,
            patientDetails.Name,
            patientDetails.Surname,
            new Date(patientDetails.BirthDate),
            row.viewModality.values().next().value,
            patientDetails.AccessionNumber,
        );
        return req;
    }
 
}


